import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { OmniscentMIDI } from './OmniscentMIDI.mjs';
import { OmniscentRenderer } from './OmniscentRenderer.mjs';

class Omniscent {
  constructor(canvas) {
    _defineProperty(this, "useHardwareRenderer", false);
    _defineProperty(this, "running", false);
    _defineProperty(this, "stopping", false);
    this.canvas = canvas;
    this.midi = new OmniscentMIDI();
    this.renderer = new OmniscentRenderer(this.canvas);
    this.reset();
  }
  reset() {
    this.running = false;
    this.stopping = false;
    this.renderer.reset();
  }
  onRender() {
    this.renderer.render(this.useHardwareRenderer);
  }
  onTimer() {
    this.midi.onTimer();
    const stopping = !this.renderer.onTimer();
    if (stopping) {
      this.stop();
    }
  }
  async start() {
    if (this.running) return;
    this.reset();
    this.running = true;
    const unitTime = 1000 / 350;
    function getTime() {
      return new Date().getTime();
    }
    function wait() {
      return new Promise(resolve => {
        setTimeout(resolve, 10);
      });
    }
    await this.midi.start();
    let lastFrame = 0;
    let startTime = getTime();
    loop: while (true) {
      const currentFrame = Math.floor((getTime() - startTime) / unitTime);
      while (lastFrame < currentFrame) {
        this.onTimer();
        if (this.stopping) break loop;
        ++lastFrame;
      }
      await wait();
    }
    this.midi.stop();
    this.running = false;
    this.stopping = false;
  }
  stop() {
    if (!this.running) return;
    this.stopping = true;
  }
}

export { Omniscent };
//# sourceMappingURL=Omniscent.mjs.map
